import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import EventRow from './EventRow';

/**
 * EventsTable component displays events in a list layout
 * @param {Array} events - Array of event objects
 * @param {string} selectedEventId - Currently selected event ID for highlighting
 */
const EventsTable = ({ events, selectedEventId }) => {
  // Calculate width based on longest status text
  // Formula: (max status length * pixels per character) + padding for icon and chip padding
  const statusChipWidth = useMemo(() => {
    if (!events || events.length === 0) return 'auto';

    const maxStatusLength = Math.max(...events.map((event) => (event.status ? event.status.length : 0)));

    // 8px per character + 48px for icon and padding
    return `${maxStatusLength * 8 + 48}px`;
  }, [events]);

  return (
    <Box>
      {events.map((event, index) => (
        <EventRow
          key={event.id}
          event={event}
          isLast={index === events.length - 1}
          selectedEventId={selectedEventId}
          statusChipWidth={statusChipWidth}
        />
      ))}
    </Box>
  );
};

export default EventsTable;
